import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid } from '@material-ui/core';
import { DateTimePicker } from '@material-ui/pickers';
import { FHEContainerForm, FHEReactSelect, FHETextField, FormEditButton, FHEButton } from 'data/components';
import { Toastr } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';

const moment = require('moment-timezone');

class FormHistory extends PureComponent {
    static propTypes = {
        addHomeHistory: PropTypes.func.isRequired,
        toggleOnForm: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        onForm: PropTypes.bool.isRequired,
        historyActions: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            sendLoading: false,
            historyForm: this.getDataForm(),
            textInput_error: {}
        };
    }

    getDataForm = () => {
        return {
            actionId: '',
            dateEvent: moment().unix(),
            comment: ''
        };
    };

    getActionsChoice = memoizeOne((historyActions = []) => {
        return historyActions.reduce((acc, action, id) => [...acc, { value: id, label: action.get('label') }], []);
    });

    isEmpty = value => {
        return value === null || /^\s*$/.test(value) || value === undefined;
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    formatForm = () => {
        const { historyForm } = this.state;

        let form = historyForm;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });

        this.setState({
            historyForm: form
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };
    onDateChange = date => {
        const { historyForm } = this.state;
        this.setState({
            historyForm: { ...historyForm, dateEvent: moment(date).unix() }
        });
    };

    handleChange = event => {
        const { historyForm, textInput_error } = this.state;
        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        this.setState({
            historyForm: { ...historyForm, [event.target.name]: event.target.value },
            textInput_error: newTextInput_error
        });
    };

    saveHistory = () => {
        const { historyForm } = this.state;
        const { addHomeHistory, toggleOnForm, history } = this.props;

        this.formatForm();

        if (this.validateForm(historyForm)) {
            this.setState({
                sendLoading: true
            });

            return addHomeHistory(historyForm)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.home.actions.addHomeHistorySuccess`));

                    toggleOnForm();
                    this.setState({
                        sendLoading: false,
                        historyForm: this.getDataForm()
                    });
                })
                .catch(error => {
                    Toastr.error(Translator.translate(`generic.home.actions.addHomeHistoryError`));
                    this.setState({
                        sendLoading: false
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate(`generic.home.actions.addHomeHistoryError`, historyForm.label)
                        );
                    }
                });
        }
    };

    validateForm = form => {
        const errors = {};

        if (this.isEmpty(form.comment)) {
            errors['comment'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.actionId)) {
            errors['actionId'] = Translator.translate('general.fields.error.any.empty');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    openForm = () => {
        const { toggleOnForm } = this.props;
        this.state.historyForm = this.getDataForm();
        toggleOnForm();
    };

    renderButtonsForm() {
        const { sendLoading } = this.state;
        const { toggleOnForm } = this.props;
        return <FormEditButton formDisabled={false} handleEdit={toggleOnForm} confirmEdit={this.saveHistory} sendLoading={sendLoading} />;
    }

    getSelectedAction = memoizeOne((role, actions) => {
        return actions.find(x => x.value === role);
    });

    handleReactSelect = (event, options) => {
        const { historyForm } = this.state;

        this.setState({
            historyForm: { ...historyForm, [options.name]: event.value }
        });
    };

    renderForm() {
        const { historyForm, textInput_error } = this.state;
        const { classes, historyActions } = this.props;
        const actions = this.getActionsChoice(historyActions)
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6}>
                        <DateTimePicker
                            disableFuture
                            className={classes.datePicker}
                            ampm={false}
                            variant="inline"
                            label={Translator.translate('general.table.column.dateEvent')}
                            value={moment.unix(historyForm.dateEvent)}
                            format="dd/MM/yyyy HH:mm"
                            autoOk
                            onChange={this.onDateChange}
                            aria-describedby="fromDate-error-text"
                        />
                    </Grid>
                    <Grid container item sm={12} md={6}>
                        <FHEReactSelect
                            name="actionId"
                            label={Translator.translate('general.table.column.supportAction')}
                            onChange={this.handleReactSelect}
                            value={this.getSelectedAction(historyForm.actionId, actions)}
                            choices={actions}
                        />
                    </Grid>
                    <Grid container item sm={12}>
                        <FHETextField
                            id="comment"
                            value={historyForm.comment}
                            error={textInput_error.comment}
                            label={Translator.translate('general.table.column.comment')}
                            name="comment"
                            multiline
                            fullWidth
                            onChange={this.handleChange}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
    renderAction() {
        const { history } = this.props;
        return (
            <Grid container justify="center" alignItems="center">
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEButton content={Translator.translate(`generic.home.button.addHistory`)} clickFunction={this.openForm} />
                </Grid>
            </Grid>
        );
    }
    render() {
        const { onForm } = this.props;

        return (
            <Fragment>
                {onForm && this.renderButtonsForm()}
                {onForm ? this.renderForm() : this.renderAction()}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        historyActions: selectors.getHistoryActions(state)
    };
}

const styles = () => ({
    datePicker: {
        width: '100%',
        paddingTop: 1,
        marginTop: 10
    }
});

export default withRouter(
    renderEnvComponent('scenes/Home/forms/FormHistory', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(FormHistory)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/forms/FormHistory.js